import { SVGProps, Ref, forwardRef } from 'react';

export const TinkoffIdBrandSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={37} height={24} viewBox="0 0 37 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="M27.002 2H9.998C4.476 2 0 6.477 0 12s4.476 10 9.998 10h17.004C32.524 22 37 17.523 37 12S32.524 2 27.002 2"
            fill="#303030"
        />
        <path
            d="M5.8 7.141h10.772v5.419a3.89 3.89 0 0 1-1.944 3.367l-3.442 1.988-3.442-1.988A3.89 3.89 0 0 1 5.8 12.56z"
            fill="#FFDD2D"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.756 9.993v1.685c.23-.261.649-.437 1.128-.437h.52v1.96c0 .521-.141.977-.352 1.228h2.264c-.209-.251-.35-.707-.35-1.227v-1.96h.52c.479 0 .898.177 1.128.438V9.995h-4.86z"
            fill="#303030"
        />
        <path d="M22.72 15.397V9.03h-2.007v6.367z" fill="white" />
        <path
            d="M27.559 15.397c2.54 0 3.797-1.351 3.797-3.183S30.098 9.03 27.772 9.03H24.19v6.367h3.372zm-.203-4.842c1.378 0 1.953.615 1.953 1.659 0 .963-.573 1.698-1.953 1.698h-1.23v-3.357z"
            fill="white"
        />
    </svg>
));
TinkoffIdBrandSize24Glyph.displayName = 'TinkoffIdBrandSize24Glyph';
